import type { ReactNode } from "react";
import { tokens } from "@/art/tokens";
import { useViewportScale } from "@/engine/useViewportScale";

/**
 * 1920×1080 고정 설계 씬 컨테이너. 모든 씬은 이 안에서 절대좌표로 배치된다.
 * 창 비율이 다르면 위·아래 또는 좌·우에 letterbox (ink 색) 띠.
 */
export function StageCanvas({ children }: { children: ReactNode }) {
    const { scale, width, height } = useViewportScale();
    const { designWidth, designHeight } = tokens.viewport;

    const stageWidth = designWidth * scale;
    const stageHeight = designHeight * scale;
    const offsetX = (width - stageWidth) / 2;
    const offsetY = (height - stageHeight) / 2;

    return (
        <div
            className="absolute inset-0 overflow-hidden"
            style={{ background: tokens.viewport.letterboxColor }}
        >
            <div
                className="absolute origin-top-left"
                style={{
                    left: offsetX,
                    top: offsetY,
                    width: designWidth,
                    height: designHeight,
                    transform: `scale(${scale})`,
                }}
            >
                {children}
            </div>
        </div>
    );
}
